import React from "react";
import { NumericFormat } from "react-number-format";

const InputNumbersSimpleTinyTB = ({
  placeholder,
  onChange,
  id,
  name,
  value,
  variant = "light",
}) => {
  return (
    <>
      <NumericFormat
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`border-[1px] rounded-[0.3rem] transition-all
        ease-in-out duration-100 placeholder-text-seondary-color text-center
         text-text-primary-color focus:border-[#aaaaaa] outline-0  focus:outline-0 focus:ring-0
         font-lato text-[1rem] w-14  max-w-[5rem]   ${
           variant === "light" ? "font-normal" : "font-bold "
         } leading-normal  py-[0.2rem] px-[0.1rem]`}
        placeholder={placeholder}
      />
    </>
  );
};

export default InputNumbersSimpleTinyTB;
